// import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';
// import Components

import { Collapse, Col, Row, Button, ButtonGroup, InputGroup, InputGroupAddon, Input } from 'reactstrap';
import Product from './Product/Product';
import NewProduct from './Product/NewProduct';
import UpDownButton from '../../Components/UpDownButton/UpDownButton';

import * as categoryActions from '../actions/categoryActions';

// import Styles
import './Category.css';
import { editProductSuccess } from './Product/actions/productActions';


class SubCategory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse : false,
            editing : false,

            koText : props.category.text['ko'],
            enText : props.category.text['en'],
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.category.id !== this.props.category.id) {
            this.setState({
                koText : this.props.category.text['ko'],
                enText : this.props.category.text['en'],
            })
        }
    }

    toggleCollapse = (e) => {
        if (!e.target.className.includes('btn')) {
            this.setState((prevState) => ({
                collapse : !prevState.collapse
            }))
        }
    }

    toggleEditing = () => {
        if(this.state.editing) {
            this.props.makeEditDoneAnything();
            this.setState({
                editing : false,
                koText : this.props.category.text['ko'],
                enText : this.props.category.text['en']
            })
        } else {
            if(this.props.makeEditAnything()) {
                this.setState({
                    editing : true,
                    koText : this.props.category.text['ko'],
                    enText : this.props.category.text['en']
                })
            }
        }
    }

    handleOnChange = (e) => {
        this.setState({
            [e.target.name] : e.target.value
        })
    }

    render() {
        const {category, mainId, mainIndex, index, products} = this.props;
        return(
            <div>
                <div className="sub-category" onClick={this.toggleCollapse}>
                    <Row>
                        {
                            this.state.editing ? 
                                <Col className="title" xs="8">
                                    <Input
                                        type="text"
                                        name="koText"
                                        value={this.state.koText}
                                        onChange={this.handleOnChange}
                                        placeholder="한글 소분류"
                                        bsSize="sm"
                                    />
                                    <Input
                                        type="text"
                                        name="enText"
                                        value={this.state.enText}
                                        onChange={this.handleOnChange}
                                        placeholder="English small category"
                                        bsSize="sm"
                                    />
                                </Col>
                                : 
                                <Col className="title" xs="8"><h6>{this.props.category.text['ko']}  /  {this.props.category.text['en']}</h6></Col>
                        }
                        <Col xs="1">
                            <UpDownButton 
                                disabled={this.state.editAnything}
                                onOrderUp={() => {
                                    //편집중인지 아닌지 확인하고 한다
                                    if(this.props.makeEditAnything()) {
                                        this.props.onSubCategoryOrderSwitch(this.props.index, this.props.index - 1, mainIndex);
                                        this.props.makeEditDoneAnything();
                                    }
                                }}
                                onOrderDown={() => {
                                    if(this.props.makeEditAnything()) {
                                        this.props.onSubCategoryOrderSwitch(this.props.index, this.props.index + 1, mainIndex);
                                        this.props.makeEditDoneAnything();
                                    }
                                }}
                            />
                        </Col>
                        <Col xs="2">
                            <Button
                                onClick={() => {
                                    if(this.state.editing) {
                                        this.props.onUpdateSubCategory(
                                            mainId, 
                                            category.id, {
                                                ko : this.state.koText,
                                                en : this.state.enText
                                            });
                                    }
                                    this.toggleEditing();
                                }}
                                color="warning"
                                size="sm"
                                outline
                            >
                                {
                                    this.state.editing ? "확인" : "편집"
                                }
                            </Button>
                            <Button
                                onClick={ () => {
                                    if(this.state.editing) {
                                        this.toggleEditing()
                                    } else {
                                        if(this.props.makeEditAnything()) {
                                            this.props.makeEditDoneAnything();
                                            this.props.onRemoveSubCategory(mainId, category.id)
                                        }
                                    }
                                }}
                                color="danger"
                                size="sm"
                                outline
                            >
                                {
                                    this.state.editing ? "취소" : "삭제"
                                }
                            </Button>
                        </Col>
                        <Col xs="1"><i className={this.state.collapse ? "up-arrow" : "down-arrow"} ></i></Col>
                    </Row>
                </div>
                <Collapse isOpen={this.state.collapse}>
                    {
                        products.length > 0 
                        ? products.map((product, index) => {
                            return (
                                <Product 
                                    makeEditAnything={this.props.makeEditAnything}
                                    makeEditDoneAnything={this.props.makeEditDoneAnything}
                                    product={product} 
                                    index={index}
                                    key={index} 
                                    prevProductGlobalIndex={index > 0 ? products[index - 1].globalIndex : null}
                                    nextProductGlobalIndex={index < (products.length - 1) ? products[index + 1].globalIndex : null}
                                    numProductInSubCategory={products.length}
                                />
                            );
                        })
                        :
                        <div className="no-product">
                            <b>상품이 없습니다</b>
                        </div>
                    }
                    <NewProduct 
                        makeEditAnything={this.props.makeEditAnything}
                        makeEditDoneAnything={this.props.makeEditDoneAnything}
                        mainCategory={mainIndex}
                        subCategory={index}
                        numProductInSubCategory={products.length}
                    />
               </Collapse>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onRemoveSubCategory : (mainId, subId) => {
            dispatch(categoryActions.removeSubCategory(mainId, subId));
        },
        onUpdateSubCategory :(mainId, subId, text) => {
            dispatch(categoryActions.updateSubCategory(mainId, subId, text));   
        },
        onSubCategoryOrderSwitch : (aIndex, bIndex, mainIndex) => {
            dispatch(categoryActions.subCategoryOrderSwitch(aIndex, bIndex, mainIndex));
        }
    }
}

export default connect(null, mapDispatchToProps)(SubCategory);



// WEBPACK FOOTER //
// ./src/pages/Admin/ProductManager/Category/SubCategory.js